import { render } from "./text_field.vue?vue&type=template&id=55baf81b&ts=true"
import script from "./text_field.vue?vue&type=script&lang=ts"
export * from "./text_field.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__